<template>
  <div class="content-container">
    <!-- Search Component -->
    <search-comp @onSearch="attachData" @onReset="onResetSearchParams">
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="das-form-row">
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Trạng thái</div>

                <el-select
                  v-model="searchParams.active"
                  placeholder="Vui lòng chọn"
                  @change="attachData"
                >
                  <el-option label="Tất cả" value=""> </el-option>
                  <el-option label="Đang hoạt động" :value="true"> </el-option>
                  <el-option label="Không hoạt động" :value="false">
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </search-comp>
    <div v-loading="loading" class="grid-scroll">
      <GridVx
        ref="agGrid"
        :columns="columns"
        :auto-size-cell="true"
        dom-layout="scroll"
        :auto-select-first-row="false"
        :row-multi-select-with-click="true"
        :rows="rows"
        class="agGrid"
        @selectionChanged="rowSelectionChanged"
      />
    </div>
    <div class="button-containers mb-0">
      <button
        class="btn primary small outline"
        :disabled="selectedRows.length === 0"
        @click="deleteBankAccount"
      >
        {{ $t('button.delete') }}
      </button>
      <button
        :disabled="selectedRows.length !== 1"
        class="btn primary small"
        @click="editBankAccount"
      >
        {{ $t('button.modify') }}
      </button>
      <button class="btn primary small" @click="dialogFormVisible = true">
        {{ $t('button.add') }}
      </button>
    </div>
    <el-dialog
      :title="
        isEdit ? $t('dialog.bankAccountUpdate') : $t('dialog.bankAccountAdd')
      "
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      width="900px"
      @open="onOpen"
    >
      <validation-observer ref="formValidator">
        <div class="das-form-container">
          <div class="das-form-group">
            <div class="das-form-row">
              <div class="das-form-col col-6">
                <validation-provider
                  rules="required|max:20"
                  name="Mã tài khoản"
                >
                  <div class="das-form-input">
                    <div class="label required">
                      {{ $t('dialog.bankCode') }}:
                    </div>
                    <div class="child-w-80">
                      <input
                        v-model="bankAccountItem.code"
                        type="text"
                        :readonly="isEdit"
                      />
                    </div>
                  </div>
                </validation-provider>
              </div>
              <div class="das-form-col col-6">
                <validation-provider
                  rules="required|max:20|integer"
                  name="Số tài khoản"
                >
                  <div class="das-form-input">
                    <div class="label required">
                      {{ $t('dialog.accountNum') }}:
                    </div>
                    <div class="child-w-80">
                      <input v-model="bankAccountItem.acc_num" type="text" />
                    </div>
                  </div>
                </validation-provider>
              </div>
            </div>
            <div class="das-form-row align-end">
              <div class="das-form-col col-6">
                <validation-provider
                  rules="required|max:50"
                  name="Tên ngân hàng"
                >
                  <div class="das-form-input">
                    <div class="label required">
                      {{ $t('dialog.bankAccountName') }}:
                    </div>
                    <div class="child-w-80">
                      <input v-model="bankAccountItem.name" type="text" />
                    </div>
                  </div>
                </validation-provider>
              </div>
              <div class="das-form-col col-6">
                <div class="checkbox-container">
                  <div class="checkbox-wrap">
                    <input
                      id="cpSpdTp3"
                      v-model="bankAccountItem.active"
                      type="checkbox"
                    />
                    <label for="cpSpdTp3">{{ $t('dialog.active') }}</label>
                  </div>
                  <div class="checkbox-wrap">
                    <input
                      id="cpSpdTp4"
                      v-model="bankAccountItem.pms_site"
                      type="checkbox"
                    />
                    <label for="cpSpdTp4">{{ $t('dialog.pmsSite') }}</label>
                  </div>
                  <div class="checkbox-wrap">
                    <input
                      id="cpSpdTp5"
                      v-model="bankAccountItem.ticket_site"
                      type="checkbox"
                    />
                    <label for="cpSpdTp5">{{ $t('dialog.ticketSite') }}</label>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="bankAccountItem.ticket_site" class="das-form-row">
              <div class="das-form-col col-6">
                <validation-provider rules="" name="Quầy bán vé">
                  <div class="das-form-input">
                    <div class="label">
                      <span>Quầy bán vé</span>
                    </div>
                    <el-select
                      v-model="bankAccountItem.ticket_office_ids"
                      placeholder=""
                      multiple
                      collapse-tags
                    >
                      <el-option
                        v-for="item in ticketOfficeOptions"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </validation-provider>
              </div>
            </div>
          </div>
        </div>
      </validation-observer>
      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small outline"
            @click="dialogFormVisible = false"
          >
            {{ $t('button.cancel') }}
          </button>
          <button
            v-if="isEdit"
            class="btn primary small"
            @click="updateBankAccount"
          >
            {{ $t('button.update') }}
          </button>
          <button v-else class="btn primary small" @click="addBankAccount">
            {{ $t('button.create') }}
          </button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import bus from '@/utils/bus'
import { CellRenderCheckboxReadonly } from '@/utils/cellRenders'
// import { required|getListBankAccountApi, addBankAccountApi, updateBankAccountApi, deleteBankAccountApi } from '@/api/configuration/accounting/chargeService.js'
import {
  getListBankAccountApi,
  addBankAccountApi,
  updateBankAccountApi,
  deleteBankAccountApi,
  getTicketOfficeOptionsApi
} from '@/api/configuration/accounting/bankAccount.js'
import { Message } from 'element-ui'
export default {
  components: {
    CellRenderCheckboxReadonly
  },
  data() {
    return {
      selectedRows: [],
      loading: false,
      columns: [
        {
          headerName: '',
          field: 'index',
          minWidth: 60,
          maxWidth: 60,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          checkboxSelection: true,
          resizable: false
        },
        {
          headerName: this.$t('grid.column.accountCode'),
          field: 'code',
          tooltipField: 'code',
          maxWidth: 200
        },
        {
          headerName: this.$t('grid.column.accountNum'),
          field: 'acc_num',
          tooltipField: 'acc_num',
          maxWidth: 200
        },
        {
          headerName: this.$t('grid.column.bankAccountName'),
          field: 'name',
          tooltipField: 'name'
        },
        {
          headerName: this.$t('grid.column.pmsSite'),
          field: 'pms_site',
          cellRenderer: 'CellRenderCheckboxReadonly',
          headerClass: 'header-cell-center',
          cellClass: 'grid-cell-align-center',
          maxWidth: 150
        },
        {
          headerName: this.$t('grid.column.ticketSite'),
          field: 'ticket_site',
          cellRenderer: 'CellRenderCheckboxReadonly',
          headerClass: 'header-cell-center',
          cellClass: 'grid-cell-align-center',
          maxWidth: 150
        },
        // {
        //   headerName: 'Thứ tự',
        //   field: 'order',
        // },
        {
          headerName: this.$t('grid.column.active'),
          field: 'active',
          cellRenderer: 'CellRenderCheckboxReadonly',
          headerClass: 'header-cell-center',
          cellClass: 'grid-cell-align-center',
          maxWidth: 150
        }
      ],
      rowId: null,
      rows: [],
      form: [],
      titlePopup: '',
      totalPage: 0,
      currentPage: 0,
      isEdit: false,
      dialogFormVisible: false,
      searchParams: {
        // pageSize: 10,
        // pageNum: 1,
        // orderTp: 'ASC',
        active: ''
      },
      bankAccountItem: {
        code: '',
        acc_num: '',
        name: '',
        order: 1,
        active: true,
        pms_site: false,
        ticket_site: false,
        ticket_office_ids: null
      },

      ticketOfficeOptions: []
    }
  },
  watch: {
    dialogFormVisible() {
      this.dialogFormVisible ? null : this.resetBankAccountItem()
    }
  },
  beforeMount() {
    this.context = { componentParent: this }
  },
  async mounted() {
    await this.getTicketOfficeOptions()
    this.attachData()
  },
  methods: {
    rowSelectionChanged(row) {
      this.selectedRows = row
    },
    onResetSearchParams() {
      this.searchParams.showNotActive = false
    },
    resetBankAccountItem() {
      this.isEdit = false
      this.bankAccountItem = {
        code: '',
        acc_num: '',
        name: '',
        order: 0,
        active: true,
        pms_site: false,
        ticket_site: false,
        ticket_office_ids: null
      }
    },
    // table controller
    onRowClick(index) {
      document.getElementById(`currency-${index}`).classList.add('row-focus')
      if (this.rowId != null) {
        document
          .getElementById(`currency-${this.rowId}`)
          .classList.remove('row-focus')
      }
      this.rowId = index
    },
    // CRUD
    async addBankAccount() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) === false) {
        return
      }
      let data = await addBankAccountApi(this.bankAccountItem)
        .then(async res => {
          const message = res.message
          await this.attachData()
          this.dialogFormVisible = false
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    },
    editBankAccount() {
      // const gridApi = this.$refs.agGrid.gridApi
      // const row = gridApi.getSelectedRows()[0]
      // if (!row) {
      //   this.$alert('Vui lòng chọn loại phí dịch vụ', 'Error', {
      //     confirmButtonText: 'OK'
      //   })
      //   return false
      // }
      this.isEdit = true
      this.dialogFormVisible = true
      Object.assign(this.bankAccountItem, this.selectedRows[0])
      this.bankAccountItem.ticket_office_ids =
        this.selectedRows[0]?.relationships?.map(
          office => office?.ticket_office_id
        )
    },
    onOpen() {},
    async deleteBankAccount() {
      const ids = this.selectedRows.map(item => item.id) || []
      this.$vxConfirm(this.$t('alert.deleteBankAccountConfirm'), () => {
        deleteBankAccountApi({
          id_list: ids
        })
          .then(async res => {
            const message = res.message
            await this.attachData()
            this.dialogFormVisible = false
            this.$message({
              type: 'success',
              message: this.$t(`successMsg.${message}`)
            })
          })
          .catch(error => {
            const message = error.response?.data?.message || 'default'
            this.$message({
              type: 'error',
              message: this.$t(`errorMsg.${message}`)
            })
          })
      })
    },
    async updateBankAccount() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) === false) {
        return
      }
      let data = await updateBankAccountApi(this.bankAccountItem)
        .then(async res => {
          const message = res.message
          await this.attachData()
          this.dialogFormVisible = false
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    },
    async getTicketOfficeOptions() {
      const res = await getTicketOfficeOptionsApi()
      this.ticketOfficeOptions = res.data
    },
    async attachData() {
      // bus.$emit('startLoader', { msg: '' })
      this.loading = true
      let data = await getListBankAccountApi(this.searchParams)
      this.loading = false
      this.rows = data.data
      this.selectedRows = []
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
